<div class="agpr-viDimensionCard">
    <div class="agpr-viDimensionCard-header">
        <span class="agpr-viDimensionCard-label">
            <span class="agpr-viDimensionCard-labelText">
                {{ (card?.dimension ? `VisibilityIntelligence.querySetup.dimensions.${card.dimension}` : '') | localize }}
            </span>
            <span class="agpr-viDimensionCard-labelCount">
                ({{ card?.questions?.length ?? 0 }})
            </span>
        </span>
        <agpr-button
            [id]="id + '_toggle'"
            class="agpr-viDimensionCard-toggleButton"
            [style]="buttonTypes.icon"
            [icon]="card?.isExpanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
            [tooltip]="card?.isExpanded ? 'Core.collapse' : 'Core.expand'"
            [initiallyFocusable]="false"
            (click)="toggle()"
        ></agpr-button>
    </div>

    <div
        class="agpr-viDimensionCard-content"
        [@cardState]="{value: card?.isExpanded ? 'expanded' : 'collapsed'}"
    >
        @if (card?.questions?.length) {
            <ul
                [id]="id + '_questionList'"
                class="agpr-viDimensionCard-questionList"
            >
                @for (question of card.questions; track question.id ?? question; let i = $index) {
                    <li
                        [id]="id + '_questionListItem_' + i"
                        tabindex="0"
                    >
                        <agpr-vi-question-card
                            [id]="id + '_question_' + i"
                            [question]="question.question"
                            [hasError]="!question.question?.trim() || !question.expectedAnswerSignals?.length"
                            [allowDelete]="allowDelete"
                            [selected]="isSelected(question)"
                            [showMetrics]="showMetrics"
                            [inverseArrows]="inverseArrows"
                            [score]="question.score"
                            [delta]="question.delta"
                            (selectChange)="questionSelected.emit(question)"
                            (deleteRequested)="questionDeleted.emit(question)"
                        ></agpr-vi-question-card>
                    </li>
                }
            </ul>
        } @else {
            <agpr-message
                class="agpr-viDimensionCard-noContent"
                [severity]="messageSeverity.noContent"
            >
                {{ 'VisibilityIntelligence.querySetup.reviewQuestion.noContent' | localize }}
            </agpr-message>
        }
    </div>
</div>
